/**
 * 新增题目类型
 */
export var ADD_QUESTION_TYPE;
(function (ADD_QUESTION_TYPE) {
    ADD_QUESTION_TYPE[ADD_QUESTION_TYPE["FREE"] = 1] = "FREE";
    ADD_QUESTION_TYPE[ADD_QUESTION_TYPE["LANGUAGE"] = 2] = "LANGUAGE";
    ADD_QUESTION_TYPE[ADD_QUESTION_TYPE["EVALUATION"] = 3] = "EVALUATION";
    ADD_QUESTION_TYPE[ADD_QUESTION_TYPE["SINGLECHIOCE"] = 4] = "SINGLECHIOCE";
})(ADD_QUESTION_TYPE || (ADD_QUESTION_TYPE = {}));
/**
 * AI考核标准类型
 */
export var CATEGORY_TYPE;
(function (CATEGORY_TYPE) {
    CATEGORY_TYPE[CATEGORY_TYPE["LANGUAGE"] = 1] = "LANGUAGE";
    CATEGORY_TYPE[CATEGORY_TYPE["SEMANTICS"] = 2] = "SEMANTICS";
    CATEGORY_TYPE[CATEGORY_TYPE["EXPRESSION"] = 3] = "EXPRESSION";
    CATEGORY_TYPE[CATEGORY_TYPE["FORM"] = 4] = "FORM";
    CATEGORY_TYPE[CATEGORY_TYPE["LANGUAGE_ABILITY"] = 6] = "LANGUAGE_ABILITY";
})(CATEGORY_TYPE || (CATEGORY_TYPE = {}));
/**
 * AI考核标准语言类型
 */
export var LANGUAGE_TYPE;
(function (LANGUAGE_TYPE) {
    LANGUAGE_TYPE[LANGUAGE_TYPE["MANDARIN"] = 2] = "MANDARIN";
    LANGUAGE_TYPE[LANGUAGE_TYPE["CANTONESE"] = 13] = "CANTONESE";
    LANGUAGE_TYPE[LANGUAGE_TYPE["JAPANESE"] = 12] = "JAPANESE";
    LANGUAGE_TYPE[LANGUAGE_TYPE["ENGLISH"] = 11] = "ENGLISH";
})(LANGUAGE_TYPE || (LANGUAGE_TYPE = {}));
/**
 * 题目类型
 */
export var QUESTION_TYPE;
(function (QUESTION_TYPE) {
    QUESTION_TYPE[QUESTION_TYPE["QA"] = 1] = "QA";
    QUESTION_TYPE[QUESTION_TYPE["COLOR_BLINDNESS"] = 2] = "COLOR_BLINDNESS";
    QUESTION_TYPE[QUESTION_TYPE["ALPHABETIC_DICTATION"] = 4] = "ALPHABETIC_DICTATION";
    QUESTION_TYPE[QUESTION_TYPE["AI_ANALYSIS"] = 6] = "AI_ANALYSIS";
    QUESTION_TYPE[QUESTION_TYPE["POLICY_DECISION_GAME"] = 7] = "POLICY_DECISION_GAME";
    QUESTION_TYPE[QUESTION_TYPE["MEMORY_GAME"] = 8] = "MEMORY_GAME";
    QUESTION_TYPE[QUESTION_TYPE["EMOTION_GAME"] = 9] = "EMOTION_GAME";
    QUESTION_TYPE[QUESTION_TYPE["SINGLECHIOCE"] = 17] = "SINGLECHIOCE";
})(QUESTION_TYPE || (QUESTION_TYPE = {}));
